import { Center, Image } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

function Face({ face }) {
  return (
    <Center width="32%" mb="2">
      <Image
        source={face.image}
        alt="NA"
        width={face.value < 5 ? '70' : '120'}
        height="70"
        borderRadius="10"
      />
    </Center>
  );
}

Face.propTypes = {
  face: PropTypes.object.isRequired,
};

export default Face;
